module.exports = __webpack_public_path__ + "static/media/First Light ZTG 0591-Edit_360.270042f2.jpeg";